module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/pc/item_02_6a65ee7e8bd2c412491a4a0d83c2fc90.jpg";